import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';
import { ProcessStatus, YesNo } from 'interfaces';

export type Menu = {
  menu_id?: number; // 메뉴 idx
  product_category_id?: number; // 상품 카테고리 idx
  tap_category_id?: number; // 최상위 카테고리 idx
  shop_information_id?: number; // 쇼/브/매/지 idx
  stock_id?: number; // 재고관리 idx
  menu_name?: string; // 메뉴명
  menu_content?: string; // 메뉴 설명
  num?: number; //수량
  price?: number; // 가격
  is_show?: (typeof YesNo)[keyof typeof YesNo]; // 노출여부
  is_refund?: (typeof YesNo)[keyof typeof YesNo]; // 환불여부
  is_inventory?: (typeof YesNo)[keyof typeof YesNo]; // 재고관리여부
  is_kiosk_show?: (typeof YesNo)[keyof typeof YesNo]; // 키오스크 노출여부
  is_store_pickup?: (typeof YesNo)[keyof typeof YesNo]; // 스토어픽업 여부
  application_status?: (typeof ProcessStatus)[keyof typeof ProcessStatus]; // 신청상태
  menu_option?: { [key: string]: Record<string, any> }; // 메뉴 옵션
  order?: number; // 노출 순서
  type?: string; // 타입
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
  sub_menu_name?: string; // 서브 메뉴명
  nutritional_information?: string; // 제품영양정보
  allergen_ingredient?: string; // 알레르기 유발 성분
  exchange_return_policy?: string; // 교환/반품 안내
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] Menu
   * --
   */
  getMenus: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_MENU, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Menu
   * --
   */
  getMenu: async (idx: number, params?: { [key: string]: string | number }) => {
    try {
      const url = parameterToPath(APIConstant.GET_MENU, { menu_id: idx });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Menu
   * --
   */
  createMenu: async (body: Menu) => {
    try {
      const res = await $http.post(APIConstant.CREATE_MENU, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Menu
   * --
   */
  updateMenu: async (body: Menu) => {
    try {
      const { menu_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_MENU, {
        menu_id: menu_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Menu
   * --
   */
  deleteMenu: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_MENU, {
        menu_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
